export default "__VITE_ASSET__55f7d3dd__"